import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { __ } from "./i18n.js";
import { rmlOpts } from "./rmlOpts.js";
function getSubfolderDescription() {
    const base = __("Subfolders offer you the possibility to bring more structure into your media library. They help you to keep the overview, even if you really have many files in your media library.");
    if (rmlOpts.others.liteHasSubfolders) {
        return /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                base,
                /*#__PURE__*/ _jsx("br", {}),
                /*#__PURE__*/ _jsx("br", {}),
                /*#__PURE__*/ _jsx("strong", {
                    children: __("Subfolders are only available in the PRO version. But you can now create an unlimited number of folders on the main level (instead of the previous max. 10 folders).")
                })
            ]
        });
    }
    return base;
}
function getProFeature(feature) {
    switch(feature){
        case "collections":
            return {
                title: __("You like collections?"),
                image: "collections.jpg",
                description: __("Get more organized with different types of folders: Collections and galleries help you to easily recognize where your image galleries are located.")
            };
        case "order-content":
            return {
                title: __("Custom content order?"),
                image: "order-content.gif",
                description: __("Get your folder contents in order and arrange your files according to a criterion (e.g. name descending) or by drag & drop.")
            };
        case "order-subfolders":
            return {
                title: __("Full order control?"),
                image: "order-subfolder.gif",
                description: __("Organize the nodes within your folder tree according to a criterion (e.g. name descending) or by drag & drop.")
            };
        case "subfolder":
            return {
                title: __("Want to create subfolders?"),
                image: "full-control.gif",
                description: getSubfolderDescription()
            };
        case "insert-media-tree-view":
            return {
                title: __("Want to switch between folders more comfortably?"),
                image: "inserting-media-dialog.gif",
                description: __("Let the complete folder tree as in your media library also be displayed in this dialog instead of searching each time in the dropdown. It is simply more comfortable!")
            };
        case "recursive-upload":
            return {
                title: __("Want to upload entire folders?"),
                description: __("With Real Media Library you can upload entire folders using drag and drop. All folders, subfolders and files will be uploaded and displayed in your media library in the same structure. Get PRO to upload folders!")
            };
        default:
            return undefined;
    }
}
export { getProFeature };
